// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024  Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@sc/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { requestRmaInformationStyles } from "@sc/Overrides/Widgets/RequestRma/RequestRmaInformation";
import { mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

requestRmaInformationStyles.fieldWrapper = {
    ...xOrderInformationStyles.headingAndTextStyles?.wrapper,
};

requestRmaInformationStyles.orderDateText = {
    ...xOrderInformationStyles.value,
};

requestRmaInformationStyles.titleText = {
    ...xOrderInformationStyles.labelWithDots,
};

requestRmaInformationStyles.billingAddressText = {
    ...mergeWithCss(xOrderInformationStyles.address?.heading, {
        as: "h2",
    }),
};

requestRmaInformationStyles.customerPOText = {
    ...xOrderInformationStyles.value,
};

requestRmaInformationStyles.billingInformationTitleText = {
    ...xOrderInformationStyles.address?.informationTitle,
};

requestRmaInformationStyles.wrapper = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

requestRmaInformationStyles.billingGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

requestRmaInformationStyles.container = {
    gap: 20,
};
